import { render, staticRenderFns } from "./chartViewStatisticalDataParent.vue?vue&type=template&id=3b394306&scoped=true"
import script from "./chartViewStatisticalDataParent.vue?vue&type=script&lang=js"
export * from "./chartViewStatisticalDataParent.vue?vue&type=script&lang=js"
import style0 from "./chartViewStatisticalDataParent.vue?vue&type=style&index=0&id=3b394306&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b394306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b394306')) {
      api.createRecord('3b394306', component.options)
    } else {
      api.reload('3b394306', component.options)
    }
    module.hot.accept("./chartViewStatisticalDataParent.vue?vue&type=template&id=3b394306&scoped=true", function () {
      api.rerender('3b394306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/menuParent/chartViewStatisticalDataParent.vue"
export default component.exports